export default __webpack_public_path__ + "static/media/apoio-decisao.8d882186.svg";